<script setup lang="ts">
import { computed, ref, watch, onMounted  } from 'vue'
import translaters from '../tradutors/assine';
import { localeStore } from '../stores/locale'
import { userStore } from "../stores/user";
import { jwtStore } from '../stores/jwt'
import Facebook from 'assets/img/facebook.jpg'
import api from '../api'
import router from '../router'
import { CredentialResponse, decodeCredential, useOneTap} from "vue3-google-signin";
import { HFaceBookLogin } from '@healerlab/vue3-facebook-login';
import { useRoute } from 'vue-router'

const storeLocale = localeStore()
const storeUser = userStore()
const storeJwt = jwtStore()

const isLoggedIn = computed(() => storeUser.isLoggedIn)
const loading = ref(false)
const emit = defineEmits(['returnMessage'])
const props = defineProps(['redirect', 'size'])
const route = useRoute()

const form = ref({
    firstName: null,
    lastName: null,
    email: null,
    emailAgain: null,
    anotherEmail: null,
    country: null,
    password: null,
    passwordAgain: null,
    emailFacebook: null,
    emailGoogle: null,    
    acept: true
  })

const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

function error(value) {
    emit('returnMessage', value)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'erro',
      erro: {
        tipo: value
      }
    })
}

function redirectSocial(name) {
    router.push({
      name,
      params: {
        locale: reactiveLocale.value
      }
    })
  }


function onSuccessSocial(response) {
    if (response.credential) { // GOOGLE
        var dataSocial = decodeCredential(response.credential)
        var dataEmail = dataSocial.email
        var dataFirstName = dataSocial.given_name
        var dataLastName = dataSocial.family_name
        var dataEmailFacebook = null
        var dataEmailGoogle = dataSocial.email  
        var dataCompany = 'google'
    } else if (response.authInfo) { // FACEBOOK
        var dataSocial = response.authInfo
        var dataEmail = dataSocial.email
        var dataFirstName = dataSocial.first_name
        var dataLastName = dataSocial.last_name
        var dataEmailFacebook = dataSocial.email
        var dataEmailGoogle = null
        var dataCompany = 'facebook'        
    }

    if (!dataEmail) {
        error('Erro Login')
        return false
    }

    let request = {
        email: dataEmail,
        company: dataCompany,
        language: reactiveLocale.value
    }
    api
      .post('v1/subscribe/checkLoginEmailSocial', request)
      .then(({ data }) => {
        if (!data.process) {
            error(data.errors)
            loading.value = false            
            return false
        }
        if (data.login) {
            storeUser.setUser(data.login.user)
            storeJwt.setJwt(data.login.jwt)
            if (props.redirect) {
                redirectSocial(props.redirect)
            } else {
                window.location.reload()
            }
        } else {
            loading.value = true            
            form.value.firstName = dataFirstName
            form.value.lastName = dataLastName
            form.value.email = dataEmail
            form.value.emailAgain = dataEmail
            form.value.anotherEmail = ''
            form.value.country = reactiveLocale.value == 'pt-br' ? 33 : 69
            form.value.password = 'X4JXrA10Gm'
            form.value.passwordAgain = 'X4JXrA10Gm'
            form.value.emailFacebook = dataEmailFacebook
            form.value.emailGoogle = dataEmailGoogle
            api
                .post('v1/subscribe/storeCreateUserAssine', form.value)
                .then(({ data }) => {
                    if (!data.process) {
                        error(data.errors)
                    }
                    if (data.login) {
                        storeUser.setUser(data.login.user)
                        storeJwt.setJwt(data.login.jwt)
                        if (props.redirect) {
                            redirectSocial(props.redirect)
                        } else {
                            window.location.reload()
                        }
                    }
                })
                .catch(
                    ({
                        response: {
                            data: { errors }
                        }
                    }) => error(errors)
                )
                .finally(() => (loading.value = false))
        }
      })
      .catch(
        ({
          response: {
            data: { errors }
          }
        }) => error(errors)
      )
      
  }

function onFailureSocial() {
    error("Login failed");
}

if (!isLoggedIn.value) {
    useOneTap({
        onSuccess: (response: CredentialResponse) => {
            onSuccessSocial(response);
        },
        onError: () => error("Erro One Tap Login")
    });  
}
</script>
<template>
    <div class="text-center mt-3 mb-5" v-if="loading">
        <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <div class="row" v-else>
        <div class="col-lg-11 col-12 text-login">
            {{ route.name == 'MyAccountPage' ? translate.loginText1 : translate.loginText}} 
        </div>
        <div class="col-12 mb-5 p-left">
            <GoogleSignInButton class="col-lg-11 col-12 d-flex justify-content-center"
                @success="onSuccessSocial"
                @error="onFailureSocial"
                theme="filled_blue"
                :width="props.size"
            ></GoogleSignInButton>      
            <div class="col-lg-1 col-12">&nbsp;</div>
            <!--
            <HFaceBookLogin class="col-lg-5 col-12 d-flex justify-content-center button-facebook"
                v-slot="fbLogin" 
                app-id="560702596402178" 
                @onSuccess="onSuccessSocial" 
                @onFailure="onFailureSocial"
                scope="email,public_profile"
                fields="email,first_name,last_name"
            >
                <div :style="`width:${props.size}px`" @click="fbLogin.initFBLogin" class="fb-button d-flex align-items-center justify-content-center">
                    <img :src="Facebook" alt="Facebook" width="36" height="36"/>
                    <div style="width: 100%; text-align: center;">{{ translate.loginFacebook }}</div>
                </div>
            </HFaceBookLogin>        
            -->
        </div>
    </div>
</template>

<style scoped lang="css">
.button-facebook {
    color: #ffffff;
    font-family: 'Exo-2';
    display: flex;
    align-items: center;
    border-radius: 5px;
}

.p-left {
    display: flex;
}

.text-login {
    text-align: center;
    font-family: 'Exo-2';
    font-size: 14px;
    line-height: 21px;
    color: #707070;
    padding-bottom: 10px;
}

:deep(.g-btn-wrapper) {
    display: inherit !important; 
} 

.fb-button {
    background-color: #4267b2;
    cursor: pointer;
    font-weight: 900;
    font-size: 14px;    
    border-radius: 5px;
    height: 40px;
}

.fb-button img {
    margin-left: 3px; 
    border-radius:3px;    
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {
    .p-left {
      display: block;
    }

    .text-login {
      text-align: center;
      padding-left: 0px;
      padding-bottom: 10px;
    }
}

</style>